<template>
  <div class="row">
    <!-- 30天注册人数 -->
    <!-- <div class="col-12">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
            <i class="tim-icons icon-molecule-40 text-primary"></i>
            近30天注册人数
          </h4>
        </template>
        <div class="chart-area">
          <line-chart
            :chart-data="lineChart1.chartData"
            :gradient-colors="lineChart1.gradientColors"
            :gradient-stops="lineChart1.gradientStops"
            :extra-options="lineChart1.extraOptions"
            :height="200"
          >
          </line-chart>
        </div>
      </card>
    </div> -->

    <!-- 30天使用激活码人数 -->
    <div class="col-lg-12 text-left">
      <card type="chart">
        <template slot="header">
          <h4
            class="card-title"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div>
              <i class="tim-icons icon-spaceship text-primary"></i
              >近30日激活人数
            </div>
            <div>
              <badge
                style="
                  font-size: 0.82475rem;
                  padding: 0.15rem 0.5rem;
                  display: inline;
                "
                type="danger"
                >(总激活:{{ totalCdk }}人)</badge
              >
            </div>
          </h4>
        </template>
        <div class="chart-area">
          <line-chart
            :labels="lineChart2.labels"
            :chart-data="lineChart2.chartData"
            :extra-options="lineChart2.extraOptions"
            :height="200"
          >
          </line-chart>
        </div>
      </card>
    </div>

    <!-- 今日解析次数分析 -->
    <div class="col-lg-6 text-left">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-primary"></i>
            今日解析次数分析（数据库提取率：{{ extractRate(today_total_downloads,today_type_2_downloads) }}）
          </h4>
        </template>
        <div class="chart-area">
          <canvas
            id="myChartBar"
            style="width: 100%; height: 100% !important"
          ></canvas>
        </div>
      </card>
    </div>

    <!-- 今日各个网站对应下载数量 -->
    <div class="col-lg-6 text-left">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
            <i class="tim-icons icon-send text-primary"></i>
            今日各网站解析数据
          </h4>
        </template>
        <div class="chart-area">
          <bar-chart
            :chart-data="barChart1.chartData"
            :extra-options="barChart1.extraOptions"
            :gradient-colors="barChart1.gradientColors"
            :gradient-stops="barChart1.gradientStops"
            :height="200"
          >
          </bar-chart>
        </div>
      </card>
    </div>



  <!-- 30天内新增续费人数 -->
    <div class="col-lg-6 text-left">
      <card type="chart">
        <template slot="header">
          <h4
            class="card-title"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-bottom:22px;
            "
          >
            <div>
              <i class="tim-icons icon-spaceship text-primary"></i
              >近30日新客首次续费人数
            </div>
            <div>
                <badge
                style="
                  font-size: 0.82475rem;
                  padding: 0.15rem 0.5rem;
                  display: inline;
                "
                type="info"
                >(新客总人数:{{ totalNewPayCount }}人)</badge
              >
              <badge
                style="
                margin-left:0.4rem;
                  font-size: 0.82475rem;
                  padding: 0.15rem 0.5rem;
                  display: inline;
                "
                type="danger"
                >(新客总支付:{{ totalNewPayTuanGouInfoCount }}元)</badge
              >
            </div>
          </h4>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="lineChart8.chartData"
            :gradient-stops="lineChart8.gradientStops"
            :extra-options="lineChart8.extraOptions"
          >
          </line-chart>
        </div>
      </card>
    </div>

<!-- 30天在线支付人数 -->
    <div class="col-lg-6 text-left">
      <card type="chart">
        <template slot="header">
          <h4
            class="card-title"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div>
              <i class="tim-icons icon-spaceship text-primary"></i
              >近30日在线支付人数
            </div>
            <div    class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <base-input style="margin-right: 20px">
                <el-date-picker
                  v-model="payselectStartTime"
                  type="date"
                  placeholder="请选择开始日期"
                >
                </el-date-picker>
              </base-input>

              <base-input style="margin-right: 20px">
                <el-date-picker
                  v-model="payselectEndTime"
                  type="date"
                  placeholder="请选择结束日期"
                >
                </el-date-picker>
              </base-input>

               <div>
                <badge
                style="
                  font-size: 0.82475rem;
                  padding: 0.15rem 0.5rem;
                  display: inline;
                "
                type="info"
                >(总人数:{{ totalpayCount }}人)</badge
              >
              <badge
                style="
                     margin-left:0.4rem;
                  font-size: 0.82475rem;
                  padding: 0.15rem 0.5rem;
                  display: inline;
                "
                type="danger"
                >(总支付:{{ totalpayTuanGouInfoCount }}元)</badge
              >
               </div>
            </div>
          </h4>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="lineChart3.chartData"
            :gradient-stops="lineChart3.gradientStops"
            :extra-options="lineChart3.extraOptions"
          >
          </line-chart>
        </div>
      </card>
    </div>

    <!-- 各网站oss提取数量 -->
    <div class="col-lg-12 text-left">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
            <i class="tim-icons icon-planet text-primary"></i>
            各网站数据库中提取数量
          </h4>
        </template>
        <div class="chart-area">
          <bar-chart
            :chart-data="barChart4.chartData"
            :extra-options="barChart4.extraOptions"
            :height="200"
          >
          </bar-chart>
        </div>
      </card>
    </div>

    <!-- 当日所有用户对应的下载次数 -->
    <div class="col-lg-12 text-left">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
            <i class="tim-icons icon-single-02 text-primary"></i>
            今日活跃人数 {{ userCount }} 人
          </h4>
        </template>
        <div class="chart-area">
          <bar-chart
            :chart-data="barChart3.chartData"
            :extra-options="barChart3.extraOptions"
            :gradient-colors="barChart3.gradientColors"
            :gradient-stops="barChart3.gradientStops"
            :height="200"
          >
          </bar-chart>
        </div>
      </card>
    </div>

    <!-- 近30天活跃人数 -->
    <div class="col-lg-12 text-left">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
            <i class="tim-icons icon-light-3 text-primary"></i>
            近30天活跃人数
          </h4>
        </template>
        <div class="chart-area">
          <line-chart
            :labels="lineChart5.labels"
            :chart-data="lineChart5.chartData"
            :extra-options="lineChart5.extraOptions"
            :height="200"
          >
          </line-chart>
        </div>
      </card>
    </div>

    <!-- 30日内活跃人数 -->
    <div class="col-lg-12 text-left">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
            <i class="tim-icons icon-app text-primary"></i>
            近30日下载量
          </h4>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="lineChart4.chartData"
            :gradient-stops="lineChart4.gradientStops"
            :extra-options="lineChart4.extraOptions"
          >
          </line-chart>
        </div>
      </card>
    </div>

    <!-- 下载数量排行榜 -->
    <div class="col-lg-12 text-left">
      <card type="chart">
        <template slot="header">
          <h4 class="card-title">
             <div    class="d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div>  <i class="tim-icons icon-calendar-60 text-primary"></i> 今日下载排行榜</div>
              <div class="d-flex justify-content-center justify-content-sm-between flex-wrap"> <base-input style="margin-right: 20px">
                <el-date-picker
                  v-model="selectStartTime"
                  type="date"
                  placeholder="请选择开始日期"
                >
                </el-date-picker>
              </base-input>
              <base-input style="margin-right: 20px">
                <el-date-picker
                  v-model="selectEndTime"
                  type="date"
                  placeholder="请选择结束日期"
                >
                </el-date-picker>
              </base-input></div>
            </div>
          </h4>
        </template>
        <div style="margin-left: 30px; margin-right: 30px">
          <base-table :data="tableDataWithRanking" :columns="columns">
            <template slot="columns">
              <th>排名</th>
              <th>用户名</th>
              <th>精品下载次数</th>
              <th>通用下载次数</th>
              <th>教辅下载次数</th>
              <th>职教下载次数</th>
              <th>免费VIP下载次数</th>
              <th>下载总次数</th>
              <th>消耗账号提取次数</th>
              <th>消耗数据库提取次数</th>
              <th>数据库提取率</th>
              <th>查看用户</th>
            </template>
            <template slot-scope="{ row }">
              <td>{{ row.rank }}</td>
              <td>
                <!-- {{ row.username }} -->
                <badge class="large-text" 
            v-if="parseFloat(extractRate(row.number_of_downloads, row.oss_down)) <= 40" type="danger">{{ row.username }}</badge>
             <span v-else>{{ row.username }}</span>
              </td>
              <td>{{ row.jingpin_count }}</td>
              <td>{{ row.tongyong_count }}</td>
              <td>
                  <badge type="danger">{{ row.jiaofu_count }}</badge>
               </td>
              <td><badge type="danger">{{ row.zhijiao_count }}</badge></td>
              <td>{{ row.free_count }}</td>
              <td><badge type="default">{{ row.number_of_downloads }}</badge></td>
              <td>
                <badge :type="parseFloat(row.user_down) >= 20 ? 'danger' : 'success'">
                  {{ row.user_down }}</badge>
                <!-- <badge type="success">{{ row.user_down }}</badge> -->
              </td>
              <td>{{ row.oss_down }}</td>
              <td>
                
                <!-- {{ extractRate(row.number_of_downloads, row.oss_down) }} -->
                <badge :type="parseFloat(extractRate(row.number_of_downloads, row.oss_down)) <= 40 ? 'danger' : 'default'">
  {{ extractRate(row.number_of_downloads, row.oss_down) }}</badge>
              </td>
              <td>
                <base-button
                  size="sm"
                  style="font-size: 0.685rem"
                  class="animation-on-hover"
                  type="danger"
                  @click="handleQueryUser(row.username)"
                  >查看</base-button
                >
              </td>
            </template>
          </base-table>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import LineChart from "src/components/Charts/LineChart";
import BarChart from "src/components/Charts/BarChart";
// import PieChart from "src/components/Charts/PieChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { http } from "../../util/http.js";
import BaseTable from "@/components/BaseTable";
import { formatDateToStandard } from "../../util/utils";
import {
  registerFormat,
  getRandomColorWithOpacityVariants,
} from "../../util/utils.js";
import Chart from "chart.js";
import Badge from "@/components/Badge";
import { Select, Option, DatePicker, TimeSelect } from "element-ui";

let lineChart1_Opetion = {
  label: "数量",
  fill: true,
  borderColor: config.colors.primary,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.primary,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: "#be55ed",
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [80, 100, 70, 80, 120, 80],
};

let lineChart2_Opetion = {
  label: "数量",
  fill: true,
  borderColor: config.colors.info,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.info,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: "#2380f7",
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [80, 100, 70, 80, 120, 80],
};

let lineChart3_Opetion = {
  label: "人数(个)",
  fill: true,
  borderColor: config.colors.danger,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.danger,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: config.colors.danger,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [],
};

let lineChart33_Opetion = {
  label: "金额(元)",
  fill: true,
  borderColor: config.colors.info,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.info,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: config.colors.info,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [10, 70, 120, 80, 20, 180],
};

let lineChart4_Opetion = {
  label: "数量",
  fill: true,
  borderColor: config.colors.danger,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.danger,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: config.colors.danger,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [],
};

let lineChart5_Opetion = {
  label: "数量",
  fill: true,
  borderColor: config.colors.info,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.info,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: "#2380f7",
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [80, 100, 70, 80, 120, 80],
};

let barChart1_Opetion = {
  label: "总次数",
  fill: true,
  borderColor: config.colors.danger,
  borderWidth: 1,
  borderDash: [],
  borderDashOffset: 0.0,
  backgroundColor: [],
  borderColor: [],
  data: [],
};

let barChart3_Opetion = {
  label: "次数",
  fill: true,
  borderColor: config.colors.danger,
  borderWidth: 1,
  borderDash: [],
  borderDashOffset: 0.0,
  backgroundColor: [],
  borderColor: [],
  data: [],
};

let lineChart8_Opetion = {
  label: "新客支付人数(个)",
  fill: true,
  borderColor: config.colors.danger,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.danger,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: config.colors.danger,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [],
};

let lineChart88_Opetion = {
  label: "新客支付金额(元)",
  fill: true,
  borderColor: config.colors.info,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.info,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: config.colors.info,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
  data: [10, 70, 120, 80, 20, 180],
};

let barChart4_Opetion = [
  {
    label: "账号提取",
    fill: true,
    // backgroundColor: config.colors.orange,
    // hoverBackgroundColor: config.colors.orange,
    // borderColor: config.colors.orange,
    borderWidth: 1,
    borderDash: [],
    backgroundColor: [],
    borderColor: [],
    borderDashOffset: 0.0,
    data: [80, 100, 70, 80, 120, 80],
  },
  {
    label: "123云盘",
    fill: true,
    // backgroundColor: config.colors.info,
    // hoverBackgroundColor: config.colors.info,
    // borderColor: config.colors.info,
    borderWidth: 1,
    borderDash: [],
    backgroundColor: [],
    borderColor: [],
    borderDashOffset: 0.0,
    data: [60, 110, 90, 70, 90, 100],
  },
  {
    label: "Redis",
    fill: true,
    // backgroundColor: config.colors.info,
    // hoverBackgroundColor: config.colors.info,
    // borderColor: config.colors.info,
    borderWidth: 1,
    borderDash: [],
    backgroundColor: [],
    borderColor: [],
    borderDashOffset: 0.0,
    data: [60, 110, 90, 70, 90, 100],
  },
];

export default {
  components: {
    LineChart,
    BarChart,
    BaseTable,
        [DatePicker.name]: DatePicker,
    Badge,
  },
  data() {
    return {
      totalNewPayTuanGouInfoCount: 0,
      totalNewPayCount: 0,
      totalpayTuanGouInfoCount: 0,
      totalpayCount: 0,
      payselectEndTime: "",
      payselectStartTime: "",
      paystartTime:"",
      payendTime:"",
      today_total_downloads:0,
      today_type_2_downloads:0,
      startTime: "",
      endTime: "",
      selectEndTime: "",
      selectStartTime: "",
      totalCdk: 0,
      columns: ["id", "username", "number_of_downloads"],
      tableData: [],
      myIndex: 0,
      userCount: 0,
      lineChart1: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [lineChart1_Opetion],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient, // 表格阴影颜色
        gradientStops: [1, 0.4, 0],
      },
      lineChart2: {
        chartData: {
          labels: [],
          datasets: [lineChart2_Opetion],
        },
        extraOptions: chartConfigs.lineChartOptionsBlue,
      },
      lineChart3: {
        extraOptions: chartConfigs.greenChartOptions,
        chartData: {
          labels: [],
          datasets: [lineChart3_Opetion, lineChart33_Opetion],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      lineChart4: {
        extraOptions: chartConfigs.greenChartOptions,
        chartData: {
          labels: [],
          datasets: [lineChart4_Opetion],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      lineChart5: {
        chartData: {
          labels: [],
          datasets: [lineChart5_Opetion],
        },
        extraOptions: chartConfigs.lineChartOptionsBlue,
        gradientStops: [1, 0.4, 0],
      },
      barChart1: {
        chartData: {
          labels: [],
          datasets: [barChart1_Opetion],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: config.colors.purpleGradient,
        gradientStops: [1, 0],
      },
      barChart2: {
        labels: ["解析总数", "账号提取", "123云盘提取", "redis提取"], // 不同颜色
        datasets: [
          {
            label: "次数",
            data: [],
            backgroundColor: [
              "rgba(255, 159, 64, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 99, 132, 0.2)",
            ],
            borderColor: [
              "rgba(255, 159, 64, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 99, 132, 1)",
            ],
            borderWidth: 1,
          },
        ],
      },
      barChart3: {
        chartData: {
          labels: [],
          datasets: [barChart3_Opetion],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: config.colors.purpleGradient,
        gradientStops: [1, 0],
      },
       lineChart8: {
        extraOptions: chartConfigs.greenChartOptions,
        chartData: {
          labels: [],
          datasets: [lineChart8_Opetion, lineChart88_Opetion],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      barChart4: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: barChart4_Opetion,
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
      },
    };
  },
  computed: {
    // 计算属性添加排名
    tableDataWithRanking() {
      return this.tableData.map((item, index) => ({
        rank: index + 1, // 增加一个 rank 属性
        ...item,
      }));
    },
    extractRate() {
      // 返回一个函数，这个函数可以接收参数
      return (downloads, ossDown) => {
        // 参数验证和处理
        const d = Number(downloads)
        const o = Number(ossDown)
        
        // 检查是否为有效数字
        if (isNaN(d) || isNaN(o) || d <= 0 || o < 0) {
          return '0.0%'
        }
        
        // 计算提取率
        let rate = (o / d) * 100
        
        // 限制范围在 0-100 之间
        if (rate < 0) rate = 0
        if (rate > 100) rate = 100
        
        // 保留1位小数并添加百分号
        return `${rate.toFixed(1)}%`
      }
    },
  },
    watch: {
    selectEndTime(newVal, oldVal) {
      if (this.selectEndTime) {
        let dateObj = new Date(newVal);
        let dataInfo = formatDateToStandard(dateObj);
        this.endTime = dataInfo;
        if (this.endTime != "" && this.startTime != "") {
          this.getHome();
        }
      }else{
        this.endTime = ""
         this.getHome()
      }
    },
    selectStartTime(newVal, oldVal) {
      if (this.selectStartTime) {
        let dateObj = new Date(newVal);
        let dataInfo = formatDateToStandard(dateObj);
        this.startTime = dataInfo;
        if (this.endTime != "" && this.startTime != "") {
          this.getHome();
        }
      }else{
        this.startTime = ""
         this.getHome()
      }
    },
    payselectEndTime(newVal, oldVal) {
      if (this.payselectEndTime) {
        let dateObj = new Date(newVal);
        let dataInfo = formatDateToStandard(dateObj);
        this.payendTime = dataInfo;
        if (this.payendTime != "" && this.paystartTime != "") {
          this.getHome();
        }
      }else{
        this.payendTime = ""
         this.getHome()
      }
    },
    payselectStartTime(newVal, oldVal) {
      if (this.payselectStartTime) {
        let dateObj = new Date(newVal);
        let dataInfo = formatDateToStandard(dateObj);
        this.paystartTime = dataInfo;
        if (this.payendTime != "" && this.paystartTime != "") {
          this.getHome();
        }
      }else{
        this.paystartTime = ""
         this.getHome()
      }
    },
  },
  created() {
   this.getHome()
  },
  methods: {
    getHome(){
 let adminToken = localStorage.getItem("adminToken");
    if (adminToken == null || adminToken == "") {
      window.location = "/login";
    }
    http
      .get("/v1/admin/getHomeInfo"+"?startTime="+this.startTime +"&endTime="+this.endTime+"&paystartTime="+this.paystartTime+"&payendTime="+this.payendTime, {
        headers: { adminToken: localStorage.getItem("adminToken") },
      })
      .then((res) => {
        if (res.data.code != 200) {
          this.$notify({
            type: "danger",
            message: res.data.message,
            timeout: 2000,
            icon: "tim-icons icon-bell-55",
          });
          return;
        }
        this.tableData = res.data.data.ranking;
        // ============================== 表格1 ==============================
        let resbigChartData = [];
        let resbigChartLabels = [];
        res.data.data.registerInfo.forEach((element) => {
          resbigChartData.push(element.registration_count);
          resbigChartLabels.push(registerFormat(element.register_date));
        });
        // 更新表格重新渲染
        lineChart1_Opetion.data = resbigChartData;
        // lineChart1_Opetion.data = [20, 50, 200, 1, 1, 1, 1, 3];
        this.lineChart1.chartData = {
          labels: resbigChartLabels,
          datasets: [lineChart1_Opetion],
        };
        // ============================== 表格1 ==============================

        // ============================== 表格2 ==============================
        this.totalCdk = res.data.data.useCdkInfo.reduce(
          (accumulator, current) => accumulator + current.use_cdk_count,
          0
        );

        let reslineChart2 = [];
        let reslineChart2Labels = [];
        res.data.data.useCdkInfo.forEach((element) => {
          reslineChart2.push(element.use_cdk_count);
          reslineChart2Labels.push(registerFormat(element.use_cdk_date));
        });
        // 更新表格重新渲染
        lineChart2_Opetion.data = reslineChart2;
        // lineChart1_Opetion.data = [20, 50, 200, 1, 1, 1, 1, 3];
        this.lineChart2.chartData = {
          labels: reslineChart2Labels,
          datasets: [lineChart2_Opetion],
        };
        // ============================== 表格2 ==============================

        // ============================== 表格3 ==============================

        this.totalpayTuanGouInfoCount = res.data.data.payInfo
          .reduce(
            (accumulator, current) => accumulator + current.total_money,
            0
          )
          .toFixed(1);
        this.totalpayCount = res.data.data.payInfo
          .reduce(
            (accumulator, current) => accumulator + current.pay_count,
            0
          );
        let reslineChart3 = [];
        let reslineChart3Labels = [];
        res.data.data.payInfo.forEach((element) => {
          reslineChart3.push(element.pay_count);
          reslineChart3Labels.push(registerFormat(element.pay_date));
        });

        let reslineChart33 = [];
        let reslineChart33Labels = [];
        res.data.data.payInfo.forEach((element) => {
          reslineChart33.push(element.total_money);
          reslineChart33Labels.push(registerFormat(element.pay_date));
        });

        // 更新表格重新渲染
        lineChart3_Opetion.data = reslineChart3;
        lineChart33_Opetion.data = reslineChart33;
        // lineChart1_Opetion.data = [20, 50, 200, 1, 1, 1, 1, 3];
        this.lineChart3.chartData = {
          labels: reslineChart3Labels,
          datasets: [lineChart3_Opetion, lineChart33_Opetion],
        };
        // ============================== 表格3 ==============================

          // ============================== 表格8 ==============================
         this.totalNewPayTuanGouInfoCount = res.data.data.data30NewPay
          .reduce(
            (accumulator, current) => accumulator + current.total_amount,
            0
          )
          .toFixed(1);
         this.totalNewPayCount = res.data.data.data30NewPay
          .reduce(
            (accumulator, current) => accumulator + current.user_count,
            0
          );

        let reslineChart8 = [];
        let reslineChart8Labels = [];
        res.data.data.data30NewPay.forEach((element) => {
          reslineChart8.push(element.user_count);
          reslineChart8Labels.push(registerFormat(element.day));
        });

        let reslineChart88 = [];
        let reslineChart88Labels = [];
        res.data.data.data30NewPay.forEach((element) => {
          reslineChart88.push(element.total_amount);
          reslineChart88Labels.push(registerFormat(element.day));
        });

        // 更新表格重新渲染
        lineChart8_Opetion.data = reslineChart8;
        lineChart88_Opetion.data = reslineChart88;
        // lineChart1_Opetion.data = [20, 50, 200, 1, 1, 1, 1, 3];
        this.lineChart8.chartData = {
          labels: reslineChart8Labels,
          datasets: [lineChart8_Opetion, lineChart88_Opetion],
        };

        // ============================== 表格8 ==============================

        // ============================== 表格4 ==============================
        let reslineChart4 = [];
        let reslineChart4Labels = [];
        res.data.data.downloadCount.forEach((element) => {
          reslineChart4.push(element.download_count);
          reslineChart4Labels.push(registerFormat(element.download_date));
        });
        // 更新表格重新渲染
        lineChart4_Opetion.data = reslineChart4;
        // lineChart4_Opetion.data = [20, 50, 200, 1, 1, 1, 1, 3];
        this.lineChart4.chartData = {
          labels: reslineChart4Labels,
          datasets: [lineChart4_Opetion],
        };
        // ============================== 表格4 ==============================

        // ============================== 表格5 ==============================
        let reslineChart5 = [];
        let reslineChart5Labels = [];
        res.data.data.data30DownloadCount.forEach((element) => {
          reslineChart5.push(element.number_of_users);
          reslineChart5Labels.push(registerFormat(element.download_date));
        });
        // 更新表格重新渲染
        lineChart5_Opetion.data = reslineChart5;
        this.lineChart5.chartData = {
          labels: reslineChart5Labels,
          datasets: [lineChart5_Opetion],
        };
        // ============================== 表格5 ==============================

        // ============================== 柱形表1 ==============================
        let resbarChart1 = [];
        let resbarChart1Labels = [];
        let rgba02 = [];
        let rgba1 = [];
        res.data.data.siteRecordInfo.forEach((element) => {
          const randomColors = getRandomColorWithOpacityVariants();
          rgba02.push(randomColors.rgba02);
          rgba1.push(randomColors.rgba1);
          resbarChart1.push(element.number_of_downloads);
          resbarChart1Labels.push(element.name);
        });
        // 更新表格重新渲染
        barChart1_Opetion.data = resbarChart1;
        barChart1_Opetion.borderColor = rgba1;
        barChart1_Opetion.backgroundColor = rgba02;
        this.barChart1.chartData = {
          labels: resbarChart1Labels,
          datasets: [barChart1_Opetion],
        };
        // ============================== 柱形表1 ==============================

        // ============================== 柱形表2 ==============================
        let resbarChart2Labels = [];
        res.data.data.downloadTypeCountInfo.forEach((element) => {
          resbarChart2Labels.push(element.total_downloads);
          resbarChart2Labels.push(element.type_1_downloads);
          resbarChart2Labels.push(element.type_2_downloads);
          resbarChart2Labels.push(element.type_3_downloads);
          this.today_total_downloads = element.total_downloads
          this.today_type_2_downloads = element.type_2_downloads
        });
        // 更新表格重新渲染
        this.barChart2.datasets[0].data = resbarChart2Labels;
        this.initChartBar();
        // ============================== 柱形表2 ==============================

        // ============================== 柱形表3 ==============================
        let resbarChart3 = [];
        let resbarChart3Labels = [];
        let rgba3_02 = [];
        let rgba3_1 = [];
        res.data.data.downloadUserCount.forEach((element) => {
          const randomColors = getRandomColorWithOpacityVariants();
          rgba3_02.push(randomColors.rgba02);
          rgba3_1.push(randomColors.rgba1);

          resbarChart3.push(element.number_of_downloads);
          resbarChart3Labels.push(element.username);
        });

        this.userCount = res.data.data.downloadUserCount.length;
        // 更新表格重新渲染
        barChart3_Opetion.data = resbarChart3;
        barChart3_Opetion.borderColor = rgba3_1;
        barChart3_Opetion.backgroundColor = rgba3_02;
        this.barChart3.chartData = {
          labels: resbarChart3Labels,
          datasets: [barChart3_Opetion],
        };

        // ============================== 柱形表3 ==============================

        // ============================== 柱形表4 ==============================
        let resbarChart4_1 = []; // 账号提取
        let resbarChart4_2 = []; // oss
        let resbarChart4_3 = []; // redis
        let resbarChart4Labels_1 = [];

        let rgba4_02 = [];
        let rgba4_1 = [];

        res.data.data.downloadByOssAndRedis.forEach((element) => {
          const randomColors = getRandomColorWithOpacityVariants();
          rgba4_02.push(randomColors.rgba02);
          rgba4_1.push(randomColors.rgba1);

          resbarChart4_1.push(element.user_download);
          resbarChart4_2.push(element.oss_download);
          resbarChart4_3.push(element.redis_download);
          resbarChart4Labels_1.push(element.name);
        });
        // 更新表格重新渲染
        barChart4_Opetion[0].data = resbarChart4_1;
        barChart4_Opetion[1].data = resbarChart4_2;
        barChart4_Opetion[2].data = resbarChart4_3;

        // 随机柱形的颜色
        barChart4_Opetion[0].borderColor = rgba4_1;
        barChart4_Opetion[0].backgroundColor = rgba4_02;

        barChart4_Opetion[1].borderColor = rgba4_1;
        barChart4_Opetion[1].backgroundColor = rgba4_02;

        barChart4_Opetion[2].borderColor = rgba4_1;
        barChart4_Opetion[2].backgroundColor = rgba4_02;

        this.barChart4.chartData = {
          labels: resbarChart4Labels_1,
          datasets: barChart4_Opetion,
        };
        // ============================== 柱形表4 ==============================
      })
      .catch((error) => {
        console.error("发生错误:", error);
        // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
      });
    },
    handleIndex() {
      this.myIndex += 1;
      return this.myIndex;
    },
    handleQueryUser(username) {
      this.$router.push({ path: "/user", query: { username: username } });
    },
    initChartBar() {
      var ctx = document.getElementById("myChartBar");
      // var ctx = document.getElementById('myChartBar').getContext('2d');
      new Chart(ctx, {
        type: "bar",
        data: this.barChart2,
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
            // xAxes: [{
            //     gridLines: {
            //         display: false
            //     }
            // }],
            // yAxes: [{
            //     gridLines: {
            //         display: false
            //     }
            // }]
          },
        },
      });
    },
  },
};
</script>
<style>
.large-text {
  font-size: 13px; /* 或者 18px、20px，根据需要调整 */
}
</style>
